import _ from 'lodash';
export default function ({ store, redirect }) {
    // If the user is not authenticated
    console.log('store.state.auth', store.state.auth)
    if (_.get(store.state.auth, 'user')) {
      return redirect('/')
    }
}